import Modal from 'storybookConfig/stories/cells/Modal';
import LeftMenu from '../LeftMenu';
import { type RootState, useAppDispatch, useAppSelector } from 'store/index';
import { closeMobileMenu } from 'store/slices/sidebar';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import Hamburger from './Hamburger';
import Logo from 'storybookConfig/stories/molecules/Logo';
import { MOBILE_HEADER_HEIGHT } from 'utils/constants';
import elevate from 'storybookConfig/mixins/elevate';

const HeadingBuffer = styled.div`
  height: ${MOBILE_HEADER_HEIGHT}px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  position: fixed;
  box-sizing: border-box;
  top: 0;
  background: ${({ theme }) => theme.color.surfaceCanvas};
  z-index: 1000;
  min-height: ${MOBILE_HEADER_HEIGHT}px;
  ${elevate('2')};
  padding: 0 8px;
`;

/* The wordmark, home; in the text colour like the sidebar's. */
const HomeLink = styled(Link)`
  display: flex;
  color: ${({ theme }) => theme.color.bodyTextPrimary};

  &:hover {
    color: ${({ theme }) => theme.color.bodyTextPrimary};
  }
`;

interface MobileMenuProps {
  showDefaultHeader: boolean;
}

const MobileMenu = ({ showDefaultHeader }: MobileMenuProps) => {
  const { mobileMenuExpanded } = useAppSelector((state: RootState) => state.sidebar);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    // Close the mobile menu if the pathname changes

    if (mobileMenuExpanded && prevPathname.current !== location.pathname) {
      dispatch(closeMobileMenu());
    }

    prevPathname.current = location.pathname;
  }, [location.pathname, dispatch, mobileMenuExpanded]);

  return (
    <>
      {showDefaultHeader && (
        <>
          <HeadingBuffer />
          <HeaderContainer>
            <Hamburger />
            <HomeLink to="/">
              <Logo height="20px" />
            </HomeLink>
          </HeaderContainer>
        </>
      )}
      {mobileMenuExpanded && (
        <Modal.Root
          show={mobileMenuExpanded}
          onHide={() => dispatch(closeMobileMenu())}
          centered
          fullScreen
        >
          <Modal.Header closeButton>Carro</Modal.Header>

          <LeftMenu />
        </Modal.Root>
      )}
    </>
  );
};

export default MobileMenu;
